export default __webpack_public_path__ + "static/media/bg-presentation.85da6c0a.jpg";